var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-title"},[_vm._v("Add Quick Link")]),_c('div',{staticClass:"page-box"},[_c('quickLinkFrom',{attrs:{"ruleForm":_vm.ruleForm}}),_c('el-button',{attrs:{"type":"warning"}},[_vm._v(" Submit ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }